import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../Globalapi/Globalapi';

const TeacherContext = createContext();

const TeacherProvider = ({ children }) => {
    const [teachers, setTeachers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Function to fetch teachers from API
    const fetchTeachers = async () => {
        try {
            const school_id = sessionStorage.getItem('school_id'); // If JWT is needed

            const jwt = sessionStorage.getItem('jwt'); // If JWT is needed
            const response = await axios.get(`${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`, {
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            });
            console.log("res",response);
            
            setTeachers(response.data.data || []);
            console.log('Fetched teachers:', response.data);
        } catch (error) {
            console.error('Error fetching teachers:', error);
            setError('Error fetching teachers');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTeachers();
    }, []);

    // Function to refresh the teacher list
    const refreshTeachers = async () => {
        setLoading(true);
        await fetchTeachers();
    };

    return (
        <TeacherContext.Provider value={{ teachers, loading, error, refreshTeachers }}>
            {children}
        </TeacherContext.Provider>
    );
};

export { TeacherProvider, TeacherContext };
